import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Case_Arrow } from "../../../../app-constants";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
function Singleproject(props) {
  const gradientStyle = {
    background: "linear-gradient(90deg, #000189 70%, rgb(255, 255, 255) 70%)",
  };
  const ColorStyle = {
    color: "#FFF",
  };
  const textAndBackgroundColor = {
    backgroundColor: "",
  };
  return (
    <div className="singleproject p-100" style={gradientStyle}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="img_logo">
              <StaticImage
                src="../../../images/location_new/singlecase/custom-logo.webp"
                alt="LogoNext"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={220}
                height={76}
              />
            </div>
            <div className="example" data-text="Feature">
              <h2 style={ColorStyle}> Passion Painting</h2>
            </div>
            <p style={ColorStyle}>
              Passion Painting Doesn’t Just Paint Houses, It’s a One Stop
              Solution
            </p>
            <Link
              to={`/case-studies/passion-painting`}
              className="case_btn"
              aria-label="TekRevol Contact"
              style={textAndBackgroundColor}
            >
              View Case Study {Case_Arrow}
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="technology_list">
              <div className="tech_name">Web App</div>
              <div className="tech_name">UI UX Design</div>
            </div>
            <div className="mx-img">
              <StaticImage
                src="../../../images/location_new/singlecase/custom-img.webp"
                alt="MoCuts"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={909}
                height={711}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Singleproject;
